import { selectIsInternalAdmin, selectLoggedinUserEmail } from 'accessors'
import { useSelector } from 'react-redux'

import { canChangeManagementCompany } from './canChangeManagementCompany'

export const useManagementCompanyChangePermission = () => {
  const userEmail = useSelector(selectLoggedinUserEmail)
  const isInternalAdmin = useSelector(selectIsInternalAdmin)

  return {
    canChangeManagementCompany: canChangeManagementCompany({
      isInternalAdmin,
      userEmail
    })
  }
}
